import React, { useState, useCallback, useContext, useMemo } from 'react';
import DropDown from '../../DropDown';
import CheckBox from '../../CheckBox';
import FilterLayout from '../FilterLayout';
import ConfigContext from '../../../contexts/ConfigContext';

const PUBLISH_OPTIONS = [
  { label: 'internal', value: 'internal' },
  { label: 'external', value: 'external' }
];

const PublishFeedOptionsFilter = ({ defaultValue, handleClose, onApply, search, onChange, hideLayout = false }) => {
  const { t } = useContext(ConfigContext);
  const [values, setValues] = useState(defaultValue || []);

  const handleChange = useCallback(
    (value) => {
      const newValues = values.includes(value) ? values.filter((item) => item !== value) : [...values, value];
      setValues(newValues);
      onChange?.(newValues);
    },
    [onChange, values]
  );

  const publishOptions = useMemo(() => PUBLISH_OPTIONS.map(({ label, value }) => ({ label: t(label), value })), [t]);

  const filteredOptions = useMemo(
    () => publishOptions.filter(({ label }) => !search || label.toLowerCase().includes(search.toLowerCase())),
    [publishOptions, search]
  );

  if (!filteredOptions.length) {
    return null;
  }

  return (
    <FilterLayout
      name={t('audience')}
      handleClose={handleClose}
      onApply={() => onApply(values)}
      hideLayout={hideLayout}>
      {filteredOptions.map(({ value, label }) => (
        <DropDown.Item key={value}>
          <CheckBox
            name={`publish-feed-option-${value}`}
            value={values.includes(value)}
            label={label}
            onChange={() => handleChange(value)}
          />
        </DropDown.Item>
      ))}
    </FilterLayout>
  );
};

export default PublishFeedOptionsFilter;
